/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BankAccountDataDto = {
    /**
     * Bank account UUID
     */
    id: string;
    /**
     * ISO-3166 alpha-2 country code of the bank account
     */
    country: BankAccountDataDto.country;
    /**
     * Full name as per bank records
     */
    accountHolderName: string;
    /**
     * Name of the bank
     */
    bankName?: Record<string, any> | null;
    /**
     * Branch name (if provided)
     */
    branchName?: Record<string, any> | null;
    /**
     * Masked account number (last 4 digits visible)
     */
    maskedAccountNumber: string;
    /**
     * IFSC code (India only; empty string for other countries)
     */
    ifscCode: string;
    /**
     * SWIFT/BIC code (UAE / international; empty string when absent)
     */
    swiftCode: string;
    /**
     * Whether the bank account has been verified
     */
    isVerified: boolean;
    /**
     * When the bank account was added
     */
    addedAt?: Record<string, any> | null;
    /**
     * Stripe Connect account ID
     */
    stripeConnectAccountId?: string | null;
    /**
     * Whether Stripe Connect onboarding is complete
     */
    stripeOnboardingComplete: boolean;
    /**
     * Whether charges are enabled on the Stripe Connect account
     */
    stripeChargesEnabled: boolean;
    /**
     * Whether payouts are enabled on the Stripe Connect account
     */
    stripePayoutsEnabled: boolean;
    /**
     * Whether details have been submitted for the Stripe Connect account
     */
    stripeDetailsSubmitted: boolean;
};
export namespace BankAccountDataDto {
    /**
     * ISO-3166 alpha-2 country code of the bank account
     */
    export enum country {
        IN = 'IN',
        AE = 'AE',
        NL = 'NL',
    }
}

